import { HighlightsTextItem } from '@cmg/design-system';
import { useIntl } from '@cmg/i18n';

import { Offering_OfferingHeader_OfferingTermsPartsFragment } from '../../../graphql';
import { getLatestFilingsPrices } from './PricingTitleItems.model';

type PricingTitleItemPros = {
  terms?: Offering_OfferingHeader_OfferingTermsPartsFragment;
  pricingCurrencyCode?: string;
};

export function IPOPricingTitleItem({
  terms,
  pricingCurrencyCode,
}: Readonly<PricingTitleItemPros>) {
  const intl = useIntl();
  const { offerPrice, ipoRangeHigh, ipoRangeLow } = getLatestFilingsPrices(terms?.filings);

  if (offerPrice) {
    return (
      <HighlightsTextItem
        name="PRICE"
        text={intl.formatNumber(offerPrice, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}
      />
    );
  }

  if (ipoRangeHigh && ipoRangeLow) {
    return (
      <HighlightsTextItem
        name="PRICE RANGE"
        text={`${intl.formatNumber(ipoRangeLow, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}–${intl.formatNumber(ipoRangeHigh, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}`}
      />
    );
  }

  return <HighlightsTextItem name="PRICE RANGE" text="-" />;
}

export function FOPricingTitleItem({ terms, pricingCurrencyCode }: Readonly<PricingTitleItemPros>) {
  const intl = useIntl();
  const { offerPrice } = getLatestFilingsPrices(terms?.filings);
  const { reOfferLow, reOfferHigh } = terms?.followOnPricing || {};

  if (offerPrice) {
    return (
      <HighlightsTextItem
        name="PRICE"
        text={intl.formatNumber(offerPrice, { format: 'currency', currency: pricingCurrencyCode })}
      />
    );
  }
  if (reOfferLow && reOfferHigh) {
    return (
      <HighlightsTextItem
        name="PRICE RANGE"
        text={`${intl.formatNumber(reOfferLow, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}–${intl.formatNumber(reOfferHigh, {
          format: 'currency',
          currency: pricingCurrencyCode,
        })}`}
      />
    );
  }
  return <HighlightsTextItem name="PRICE RANGE" text="-" />;
}
